import getDetail from "@/api/endpoint/project/get-detail";
import { getDetailReview } from "@/api/endpoint/reviews/get-detail-reviews";
import Button from "@/components/Button";
import { Meta } from "@/components/Seo/Meta";
import { USER_TYPE } from "@/constants/common-constant";
import { STATIC_DOMAIN } from "@/constants/environment";
import { fileType } from "@/constants/file";
import { DEFAULT_LOGO_PROJECT } from "@/constants/project-constant";
import { DeviceContext } from "@/context/device.context";
import { ProjectContextProvider } from "@/context/project.context";
import { resizeOnFlyUrl } from "@/utils";
import { IReviewItem, ProjectReview } from "Models";
import { getCookie } from "cookies-next";
import { GetServerSidePropsContext } from "next";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useContext, useMemo } from "react";

const ReviewDetail = dynamic(() => import("@/modules/Desktop/ReviewDetail"));
const ReviewDetailMobile = dynamic(
  () => import("@/modules/Mobile/ReviewDetail")
);

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { query } = context;
  const headers = getCookie("headers", {
    ...context,
  });

  try {
    const reviewDetail = await getDetailReview(
      query.id as string,
      headers
        ? {
            ...JSON.parse(`${headers}`),
          }
        : {
            usertype: USER_TYPE.ANONYMUS,
            fingerprint: `${Math.random()}`,
          }
    );
    const project = await getDetail(reviewDetail?.[0].project);

    return {
      props: {
        project,
        reviewDetail,
        // projectListVote,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

export default function Review(props: {
  reviewDetail: IReviewItem[];
  project: ProjectReview;
}) {
  const { isMobile } = useContext(DeviceContext);

  const ogImage = useMemo(() => {
    const existImage = props.reviewDetail?.[0].media?.find(
      (e) => e.name.match(fileType.image)?.length
    );

    if (existImage)
      return resizeOnFlyUrl({
        resizingType: "fill",
        gravity: "ce",
        width: 404,
        height: 270,
        uri: existImage.uri,
      });
    else
      return props.reviewDetail?.[0].createdBy?.avatar
        ? props.reviewDetail?.[0].createdBy.avatar
        : props.project?.logo?.uri
        ? resizeOnFlyUrl({
            resizingType: "fill",
            gravity: "ce",
            width: 600,
            height: 315,
            uri: props.project.logo.uri,
          })
        : STATIC_DOMAIN + "/" + DEFAULT_LOGO_PROJECT;
  }, [props]);

  return (
    <>
      {props.project?._id ? (
        <ProjectContextProvider
          project={props.project}
          reviewDetail={props.reviewDetail}
          // projectListVote={props.projectListVote}
        >
          <Meta
            title={props.project.title}
            description={props.reviewDetail?.[0].comment}
            ogImage={{
              width: 600,
              height: 315,
              url: ogImage,
              alt: props.project.title,
            }}
          />
          {isMobile ? <ReviewDetailMobile /> : <ReviewDetail />}
        </ProjectContextProvider>
      ) : (
        <div className="w-screen h-[100vh] gap-8 flex items-center justify-center flex-col">
          <h1>Không tìm thấy dự án</h1>
          <Link href={"/"}>
            <Button btnType="filled">Về trang chủ</Button>
          </Link>
        </div>
      )}
    </>
  );
}
